/** Plain (non-signal) filter categories — keyed objects we strip/merge by key. */
export const KEYED_FILTER_CATEGORIES = ["contactsFilters", "leadsFilters", "appsFilters"] as const;

export type KeyedFilterCategory = (typeof KEYED_FILTER_CATEGORIES)[number];

export const isKeyedFilterCategory = (category: string): category is KeyedFilterCategory =>
    (KEYED_FILTER_CATEGORIES as readonly string[]).includes(category);
